<app-whatsapp-btn></app-whatsapp-btn>
<div class="bg-[#FEFAF2] p-8 mx-auto rounded-lg min-h-[100vh]">
  <div class="w-[70%] mx-auto pt-[50px]">
    <h6 class="text-[var(--lightRed)]">
      Que bom te ver de volta, {{ name }}! <i class='bx bx-rocket'></i>
    </h6>
    <p class="text-[var(--lightRed)]">Veja um resumo da sua jornada até aqui:</p>
  </div>

  <ul class="flex gap-5 mx-auto w-[70%]" id="user_infos">
    <li class="stat_li">
      <i class='bx bx-brain'></i>
      Questões Resolvidas:
      {{ totalAnswers }}
    </li>
    <li class="stat_li">
      <i class='bx bx-check'></i>
      Questões Acertadas:
      {{ totalRightAnswers }}
    </li>
    <li class="stat_li">
      <i class='bx bx-x'></i>
      Questões Erradas:
      {{ totalWrongAnswers }}
    </li>
    <li id="view-more">
      <a routerLink="../my-space/my-statistics">Ver mais </a>
      <i class='bx bx-link-external'></i>
    </li>
  </ul>

  <div *ngIf="isLoading2"
    class="w-[70%] h-[100%] mx-auto mt-[25px] bg-white rounded-lg p-6 flex items-center justify-center flex flex-col gap-4">

    <div
      class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg">
    </div>
    <span class="text-[--lightRed]">Carregando...</span>
  </div>

  <div *ngIf="!isLoading2 && dates.length === 0"
    class="w-[85%] h-[100%] mx-auto mt-[25px] bg-white rounded-lg p-6 flex items-center justify-center flex flex-col gap-4">
    <span class="text-[var(#669BBC)]">Nenhum registro encontrado...</span>
  </div>

  <div *ngIf="dates.length > 0" class="w-[70%] h-[80%] mx-auto mt-[25px] bg-white text-[#1c7db9] rounded-lg p-6">
    <chart-line [labels]="dates" [corrects]="correctsData" [wrongs]="wrongsData"></chart-line> <!-- Exibe o gráfico -->
  </div>
</div>

<div class="w-[100%] mx-auto text-[var(--lightRed)] text-center p-10 rounded-lg bg-[#FEFAF2]">
  <h6>
    <i class='bx bx-book-reader'></i>
    Últimos Simulados:
  </h6>
  <div class="w-[71%] mx-auto h-[50%px] bg-white rounded-lg  content-center p-5 mb-[50px] ">
    <div *ngIf="isLoading" class="text-center flex justify-center items-center flex-col gap-5">
      <div
        class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg">
      </div>
      <span class="text-[--lightRed]">Carregando Simulados...</span>
    </div>
    <div *ngIf="!isLoading && exams.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
      <div *ngFor="let exam of exams | slice:0:6 "
        class="card flex flex-col text-left bg-white p-[15px] w-[100%]  border border-[#1c7db9] rounded-lg">
        <span class="text-[#1c7db9] text-[20px]"><i class='bx bx-cube-alt'></i> {{ exam.title }}</span>
        <span
          class="text-[--purpleBack] text-[8px] flex items-center gap-1 w-[100%] h-[100PX] break-words overflow-auto mt-2.5 mb-2.5 leading-normal">
          {{ exam.description }}
        </span>
        <div class="flex flex-row flex-wrap justify-between items-center">
          <div class="flex flex-col">
            <span class="text-[#1c7db9] text-[12px]"><i class="bx bx-book-open"></i> {{
              exam.qcodes.split('/').length
              }} Questões</span>
            <span class="text-[#1c7db9] text-[12px]">
              <i class="bx bxs-calendar"></i>
              {{ exam.created_at | date:'dd/MM/yyyy HH:mm:ss':'-0300' || 'Data não disponível' }}
            </span>
          </div>
          <button
            class="text-white bg-[var(--lightRed)] w-fit rounded-[5px] text-[15px]  h-fit px-2 text-[10px] cursor-pointer border hover:border-red-700 hover:bg-white hover:text-[var(--lightRed)]"
            [routerLink]="['/exam', exam.id]">
            <i class='bx bx-play-circle'></i> Iniciar Simulado
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="!isLoading && exams.length === 0" class="text-center">
      <span class="text-[var(--lightRed)] ">
        Nenhum simulado disponível no momento.
      </span>
    </div>
    <a *ngIf="!isLoading && exams.length > 0" routerLink="../study-environment/exams-view">
      Ver mais
      <i class='bx bx-link-external'></i>
    </a>
  </div>
</div>